import React from "react";
import { Drawer, Box, TextField, MenuItem, FormControlLabel, Checkbox, Button, Grid } from "@mui/material";
import { BranchItem } from "./studentBranchLinkApi";

interface Props {
  open: boolean;
  onClose: () => void;
  branches: BranchItem[];
  initial: {
    studentName: string;
    academicSessionId: string;
    branchId?: string;
    isPrimaryBranch?: boolean;
    linkReason?: string;
    linkedDate?: string;
  };
  onSubmit: (data: { academicSessionId: string; branchId: string; isPrimaryBranch: boolean; linkReason: string; linkedDate: string }) => void;
}

const StudentBranchLinkForm: React.FC<Props> = ({ open, onClose, branches, initial, onSubmit }) => {
  const [branchId, setBranchId] = React.useState(initial.branchId || "");
  const [sessionId] = React.useState(initial.academicSessionId);
  const [isPrimary, setIsPrimary] = React.useState(!!initial.isPrimaryBranch);
  const [reason, setReason] = React.useState(initial.linkReason || "");
  const [date, setDate] = React.useState(
    initial.linkedDate || new Date().toISOString().split("T")[0]
  );

  const handleSave = () => {
    if (!branchId) return;
    onSubmit({
      academicSessionId: sessionId,
      branchId,
      isPrimaryBranch: isPrimary,
      linkReason: reason,
      linkedDate: date,
    });
  };

  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box sx={{ width: 360, p: 2 }}>
        <Box sx={{ mb: 2, fontWeight: 600 }}>Link Branch</Box>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField label="Student" value={initial.studentName} fullWidth disabled />
          </Grid>
          <Grid item xs={12}>
            <TextField label="Academic Session" value={initial.academicSessionId} fullWidth disabled />
          </Grid>
          <Grid item xs={12}>
            <TextField select label="Branch" fullWidth value={branchId} onChange={(e) => setBranchId(e.target.value)}>
              {branches.map((b) => (
                <MenuItem key={b.id} value={b.id}>
                  {b.branchName || b.branchCode}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel control={<Checkbox checked={isPrimary} onChange={(e) => setIsPrimary(e.target.checked)} />} label="Primary Branch" />
          </Grid>
          <Grid item xs={12}>
            <TextField label="Link Date" type="date" fullWidth value={date} onChange={(e) => setDate(e.target.value)} />
          </Grid>
          <Grid item xs={12}>
            <TextField label="Reason" fullWidth value={reason} onChange={(e) => setReason(e.target.value)} />
          </Grid>
          <Grid item xs={12} sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
            <Button onClick={onClose}>Cancel</Button>
            <Button variant="contained" onClick={handleSave}>
              Save Link
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Drawer>
  );
};

export default StudentBranchLinkForm;
